import { render } from "./ComplianceSingleClaimComponent.vue?vue&type=template&id=cf9d6066&scoped=true"
import script from "./ComplianceSingleClaimComponent.vue?vue&type=script&lang=js"
export * from "./ComplianceSingleClaimComponent.vue?vue&type=script&lang=js"

import "./ComplianceSingleClaimComponent.vue?vue&type=style&index=0&id=cf9d6066&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf9d6066"]])

export default __exports__